import { http } from 'http';
import { createPaginationQuery } from 'helpers/store';
import { getQueryFilters } from 'utils/filters';

export default {
  getPublications: ({ pagination, filters }) =>
    http.get(
      `/webh/campaigns/masive${createPaginationQuery(pagination)}${getQueryFilters(filters)}`
    ),
  getPublicationDetail: publicationId =>
    http.get(`/webh/campaigns/masive/getmasivepublicationdetails?id=${publicationId}`),
  getMasterDataMasive: () => http.get('/masterdata/masive'),
  getImagesVehicleId: vehicleId => http.get(`VehicleImages/list/${vehicleId}`)
};
